export const borders = {
  'pt-none': '0px',
  'pt-sm': '1px solid',
  'pt-md': '2px solid',
  'pt-lg': '4px solid',
};
